import React from "react"
import classnames from "classnames"
import styles from "./MyMazdaLogin.less"
import gtmHandler from "AtomicUtils/gtmHandler"
import { InputEmail, InputPassword, InputCheckBox, A, Button, H3,  FormGroup, Space } from "AtomicComponents"
import { AlertList } from "AtomicContainers"
import fetchAPI from "AtomicUtils/fetchAPI"
import { fromLinkInputs, formLinkSubmit } from "AtomicUtils/formHandler"
import MESSAGES from "AtomicConstants/MESSAGES"
import urlHandler from "AtomicUtils/urlHandler"

class MyMazdaLogin extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      form: {
        password: {
          validations: {
            required: MESSAGES.PASSWORD_REQUIRED
          }
        },
        email: {
          validations: {
            required: MESSAGES.EMAIL_REQUIRED,
            email: MESSAGES.EMAIL_INVALID
          }
        },
        rememberMe: {
          validations: {}
        },
        submitButton: { disabled: true }
      },
      success: false,
      errorMessage: null
    }
  }

  _handleSubmit = async (event) => {
    if (event) event.preventDefault()
    gtmHandler({
      pageCategory: "MyMazda Login Form",
      pageAction: "MyMazda Login Form - Login"
    })
    const { loading, form } = this.state
    if (!loading && !form.submitButton.disabled) {
      await this.setState({
        loading: true
      }, async () => {
        const { loginApiEndpoint, successfulLoginPageUrl } = this.props
        const { form } = this.state
        await fetchAPI({
          method: "POST",
          url: loginApiEndpoint,
          body: {
            username: form.email.value,
            password: form.password.value,
            rememberMe: form.rememberMe.value
          }
        })
          .then(async (response) => {
            const json = await response.json()
            const { success, errorMsg } = json
            if (!success) {
              this.setState({
                errorMessage: errorMsg,
                loading: false
              })
            } else {
              // successful
              new urlHandler(successfulLoginPageUrl).redirect()
            }
          })
          .catch((response) => {
            this.setState({
              errorMessage: response.message || `Failed with status ${response.status}`,
              loading: false
            })
          })
      })
    }
  }

  render() {
    const {
      buttonText = "LOG IN", resetPasswordPageUrl
    } = this.props
    const { loading, errorMessage } = this.state


    return (
      <div className={classnames({
        [styles.MyMazdaLogin]: true
      })}>
        <div className={classnames({
          [styles.MyMazdaLoginForm]: true
        })}>
          <form method="POST" onSubmit={this._handleSubmit}>
            <H3>
              {buttonText}
            </H3>
            <FormGroup>
              <InputEmail
                name="email"
                label="Email"
                {...fromLinkInputs(this, "email")}
                onBlur={()=>{
                  gtmHandler({
                    pageCategory: "MyMazda Login Form",
                    pageAction: "MyMazda Login Form - Entered \"EMAIL\""
                  })
                }}
              />
            </FormGroup>
            <FormGroup>
              <InputPassword
                name="password"
                label="Password"
                {...fromLinkInputs(this, "password")}
                onBlur={()=>{
                  gtmHandler({
                    pageCategory: "MyMazda Login Form",
                    pageAction: "MyMazda Login Form - Entered \"PASSWORD\""
                  })
                }}
              />
            </FormGroup>
            <FormGroup show checkbox>
              <InputCheckBox
                name="rememberMe"
                label={"Remember me"}
                {...fromLinkInputs(this, "rememberMe", () => {
                  gtmHandler({
                    pageCategory: "MyMazda Login Form",
                    pageAction: "MyMazda Login Form - checked \"Keep me logged in\""
                  })
                })}
              />
            </FormGroup>

            <FormGroup>
              {errorMessage &&
                <AlertList data={errorMessage} />
              }
              <Button
                styleName="black"
                loading={loading}
                fullWidth
                {...formLinkSubmit(this, this._handleSubmit)}
              >
                {buttonText}
              </Button>
              <Space />
              {resetPasswordPageUrl &&
                <A
                  href={resetPasswordPageUrl}
                  onClick={()=>{
                    gtmHandler({
                      pageCategory: "MyMazda Login Form",
                      pageAction: "MyMazda Forgot password Form - Reset\""
                    })
                  }}
                  styleName="black"
                  external>
                    Forgot my password >
                </A>
              }
            </FormGroup>
          </form>
        </div>
      </div>
    )
  }
}


export default MyMazdaLogin



// WEBPACK FOOTER //
// ./src/AtomicContainers/MyMazdaLogin/MyMazdaLogin.jsx